import { DevicePluginFacade, JWebCoreFacade } from './facades';
import { initializingJWebAndStates } from './Initializer';
import { StaticDeviceInfoData } from './types';
export * from './facades';

// Re-export JWebEnums for convenience
export * as JWebEnums from './JWebEnums';

// Start initialization immediately on module load
initializingJWebAndStates().catch((error) => {
  console?.error?.(`Error during JWeb initialization: ${error}`);
});

// Backwards compatibility - delegate to JWebCoreFacade
export function JWebErrorHandler<T>(object: Record<string, any>): T {
  return JWebCoreFacade.JWebErrorHandler<T>(object);
}

// Backwards compatibility
export async function isNative(): Promise<boolean> {
  return await JWebCoreFacade.isNative();
}

/**
 * @TODO: Move this code to the proper place in the future.
 *
 */
// Only use this for properties that don't change!
let getStaticDeviceInfoDataPromise: Promise<StaticDeviceInfoData>;

async function getStaticDeviceInfoData(): Promise<StaticDeviceInfoData> {
  if (!getStaticDeviceInfoDataPromise) {
    getStaticDeviceInfoDataPromise = DevicePluginFacade.getDeviceInfo()
      .then((deviceInfo) => ({
        appBuild: deviceInfo.appBuild,
        appVersion: deviceInfo.appVersion,
        jWebViewVersion: deviceInfo.jWebViewVersion,
        platform: deviceInfo.platform,
        osVersion: deviceInfo.osVersion
      }))
      .catch((error) => {
        console.error('Failed to get JWeb Device info:', error);
        getStaticDeviceInfoDataPromise = undefined;
        return {};
      });
  }

  return getStaticDeviceInfoDataPromise || {};
}

export async function getJWebAppVersion(): Promise<string> {
  try {
    const deviceInfo = await getStaticDeviceInfoData();
    return deviceInfo.appVersion || '';
  } catch (error) {
    console.error('Error in getJWebAppVersion:', error);
    return '';
  }
}

let getPlatformPromise: Promise<string>;

export async function getPlatform(): Promise<string> {
  if (!getPlatformPromise) {
    getPlatformPromise = (async () => {
      try {
        const isNativeEnvironment = await isNative();
        if (isNativeEnvironment) {
          return (await getStaticDeviceInfoData())?.platform || '';
        }

        return (await JWebCoreFacade.getPlatform()) || '';
      } catch (error) {
        console.error('Error in getPlatform:', error);
        return '';
      }
    })();
  }

  return await getPlatformPromise;
}

// eslint-disable-next-line @typescript-eslint/no-floating-promises
getPlatform();
